import { render, staticRenderFns } from "./CompetitionsViewQuestionCreate.vue?vue&type=template&id=be2a7b84&"
import script from "./CompetitionsViewQuestionCreate.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewQuestionCreate.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsViewQuestionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports